<template>
    <button
        :id="id"
        :aria-controls="tab"
        :class="classes"
        role="tab"
        type="button"
        @click="changeTab(tab)"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: ['tab', 'activeTab', 'changeTab'],
    computed: {
        isActive() {
            return this.tab === this.activeTab;
        },
        id() {
            return this.tab + '-button'
        },
        classes() {
            return {
                'w-1/2': true,
                'text-gray-500': !this.isActive,
                'text-black': this.isActive,
                'hover:text-black': true,
                'border-0': true,
                'border-b': !this.isActive,
                'border-b-2': this.isActive,
                'border-gray-600': !this.isActive,
                'border-bisnow': this.isActive,
                'bg-white': true,
                'py-4': true,
            }
        }
    },
};
</script>
